import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="container-max px-2.5">
        <div className="flex justify-between items-center h-16 md:h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="/assets/images/logo.svg" 
              alt="Nikalo Safe Logo" 
              className="w-20 sm:w-24 md:w-[154px] h-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8"> 
            <Link to="/" className="text-black hover:text-primary transition-colors font-medium px-3 py-2 text-sm xl:text-base">
              Home
            </Link>
            <Link to="/about" className="text-black hover:text-primary transition-colors font-medium px-3 py-2 text-sm xl:text-base">
              About Us
            </Link>
            <Link to="/solutions" className="text-black hover:text-primary transition-colors font-medium px-3 py-2 text-sm xl:text-base">
              Solutions
            </Link>
            <Link to="/contactus" className="flex items-center justify-center bg-white text-primary border border-primary hover:bg-primary hover:text-white transition-colors font-medium h-10 px-4 xl:px-6 rounded-xl text-sm xl:text-base">
              Contact Us
            </Link>
          </div>

          {/* Tablet Navigation (hidden on mobile and desktop) */}
          <div className="hidden md:flex lg:hidden items-center space-x-4">
            <Link to="/" className="text-black hover:text-primary transition-colors font-medium px-2 py-2 text-sm cursor-pointer">
              Home
            </Link>
            <Link to="/about" className="text-black hover:text-primary transition-colors font-medium px-2 py-2 text-sm cursor-pointer">
              About
            </Link>
            <Link to="/solutions" className="text-black hover:text-primary transition-colors font-medium px-2 py-2 text-sm cursor-pointer">
              Solutions
            </Link>
            <Link to="/contactus" className="flex items-center justify-center bg-white text-primary border border-primary hover:bg-primary hover:text-white transition-colors font-medium h-9 px-4 rounded-xl text-sm">
              Contact
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-black hover:text-primary transition-colors p-2"
              aria-label="Toggle menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-100 bg-white">
            <div className="px-4 py-4 space-y-2">
              <Link 
                to="/" 
                className="block px-4 py-3 text-black hover:text-primary hover:bg-gray-50 transition-colors font-medium rounded-lg cursor-pointer"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className="block px-4 py-3 text-black hover:text-primary hover:bg-gray-50 transition-colors font-medium rounded-lg"
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              <Link
                to="/solutions"
                className="block px-4 py-3 text-black hover:text-primary hover:bg-gray-50 transition-colors font-medium rounded-lg"
                onClick={() => setIsMenuOpen(false)}
              >
                Solutions
              </Link>
              <div className="pt-4 pb-2 border-t border-gray-100">
                <Link to="/contactus" className="flex items-center justify-center block w-full text-center h-12 px-6 bg-white text-primary border border-primary hover:bg-primary hover:text-white transition-colors font-medium rounded-xl">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 